"use strict";

export function initInScope ($scope) {
    $scope.find('.js-floating-datepicker').on('change',function (e) {
        $(this).closest('.js-datepicker').find('label').addClass('has-value');
    });
}
